module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (125).371a2a37.jpg";